import type { Nationality } from "../../../lecturas-common/location/nationality.model";
import { DataSource } from "./data-source";

export class NationalitiesDataSource extends DataSource<Nationality>{
    constructor(){
                super("api/nationalities")
                
    
        }
}